export function* resetAllModelStatesOnWorkspaceSwitch(put) {
  yield put({ type: 'connections/resetAll' });
  yield put({ type: 'credentials/resetAll' });
  yield put({ type: 'dashboard/resetAll' });
  yield put({ type: 'dataObjects/resetAll' });
  yield put({ type: 'dataset/resetAll' });
  yield put({ type: 'datasetTests/resetAll' });
  yield put({ type: 'downloads/resetAll' });
  yield put({ type: 'events/resetAll' });
  yield put({ type: 'flows/resetAll' });
  yield put({ type: 'folders/resetAll' });
  yield put({ type: 'hub/resetAll' });
  yield put({ type: 'insight/resetAll' });
  yield put({ type: 'insightMemory/resetAll' });
  yield put({ type: 'notifications/resetAll' });
  yield put({ type: 'overlay/resetAll' });
  yield put({ type: 'sources/resetAll' });
  yield put({ type: 'visualization/resetAll' });
}

export function* resetAllModelStatesOnLogout(put) {
  // must reset these first, in order to logout properly
  yield put({ type: 'login/resetAll' });
  yield put({ type: 'user/resetAll' });
  yield put({ type: 'user2/resetAll' });
  yield put({ type: 'organization/resetAll' });
  yield put({ type: 'workspaces/resetAll' });

  // then reset all workspace-scoped state
  yield* resetAllModelStatesOnWorkspaceSwitch(put);
}

const GlobalModel = {
  namespace: 'global',
  state: {},
  effects: {
    *resetAllModelStatesOnLogout(_, { put }) {
      yield* resetAllModelStatesOnLogout(put);
    },
    *resetAllModelStatesOnWorkspaceSwitch(_, { put }) {
      yield* resetAllModelStatesOnWorkspaceSwitch(put);
    },
  },
  reducers: {},
  subscriptions: {
    setup({ history }) {
      // Subscribe history(url) change, trigger `load` action if pathname is `/`
      history.listen(({ pathname, search }) => {
        if (typeof window.ga !== 'undefined') {
          window.ga('send', 'pageview', pathname + search);
        }
      });
    },
  },
};

export default GlobalModel;
